import { ActionType, GlobalStateInterface } from "./Types";

const Reducer = (state: GlobalStateInterface, action: ActionType): any => {
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "SET_CASE_STATUS":
      return {
        ...state,
        caseStatuses: action.payload,
      };
    case "SET_MILESTONE_TYPES":
      return {
        ...state,
        milestoneTypes: action.payload,
      };
    case "SET_PURCHASE_STATUS":
      return {
        ...state,
        purchaseStatuses: action.payload,
      };
    case "SET_DEVELOPMENTS":
      return {
        ...state,
        developments: action.payload,
      };
    default:
      return state;
  }
};

export default Reducer;
